import { Authentication } from "@dashboard-v3/api";
import { StorageAccountItem, StorageAccountValue } from "../types";

export enum StorageAccountStatus {
  OK = "OK",
  NOT_FOUND = "NOT_FOUND",
  OUT_OF_SYNC = "OUT_OF_SYNC",
}

export const isIndividual = (value: Authentication) => value === "INDIVIDUAL";
export const isOrganization = (value: Authentication) =>
  value === "ORGANIZATION";

// TODO: Remove and use useCloudStorageStatus
export const getCloudStorageStatus = (
  value: StorageAccountValue | null,
  availableAccounts: StorageAccountItem[]
) => {
  if (!value) return StorageAccountStatus.OK;
  if (!availableAccounts) return StorageAccountStatus.OK;

  if ("id" in value) {
    const account = availableAccounts.find(
      ({ storageAccount }) => storageAccount?.id === value.id
    );

    if (!account) return StorageAccountStatus.NOT_FOUND;
    if (account.option.needsReAuth) return StorageAccountStatus.OUT_OF_SYNC;

    return StorageAccountStatus.OK;
  }

  const { authentication, provider } = value;
  const isIndividual =
    authentication === "INDIVIDUAL" || provider === "DROPBOX";

  if (isIndividual) {
    const account = availableAccounts?.find(
      ({ storageAccount }) =>
        storageAccount &&
        storageAccount.userId === value.userId &&
        storageAccount.provider === value.provider
    );

    if (!account) return StorageAccountStatus.NOT_FOUND;

    if (account.option.needsReAuth) {
      return StorageAccountStatus.OUT_OF_SYNC;
    }
  }

  return StorageAccountStatus.OK;
};
